import _styled from "styled-components";
import { useTranslation } from 'next-i18next';
import { Title, JobOfferBenefits } from '../../';
import LongParagraph from '../../design-system/long-paragraph';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var JobContract = function JobContract(_ref) {
  var contractContent = _ref.contractContent,
      jobBenefits = _ref.jobBenefits;

  var _useTranslation = useTranslation('common'),
      t = _useTranslation.t;

  return /*#__PURE__*/_jsxs(Wrapper, {
    children: [contractContent ? /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Title, {
        content: t('contract_title'),
        icon: "DocumentTextIcon",
        variant: "h4-large",
        fontWeight: "semibold",
        textColor: "black"
      }), /*#__PURE__*/_jsx(LongParagraph, {
        content: contractContent,
        isHtml: true,
        maxLength: 450,
        title: t('contract_title'),
        headerIcon: "DocumentTextIcon",
        btnTitle: t('keep_on_reading'),
        noSlice: true
      })]
    }) : null, jobBenefits !== null && jobBenefits !== void 0 && jobBenefits.length ? /*#__PURE__*/_jsx(JobOfferBenefits, {
      jobBenefits: jobBenefits
    }) : null]
  });
};
export default JobContract;

var Wrapper = /*#__PURE__*/_styled.div.withConfig({
  displayName: "job-contract__Wrapper",
  componentId: "sc-14c2p19-0"
})({
  "display": "flex",
  "flexDirection": "column",
  "gap": "1rem"
});